import type { DataTableColumn } from '@/components/custom/erp';
import type { HanThanhToan } from '@/types/schemas';

export function getDataTableColumns(): DataTableColumn<HanThanhToan>[] {
  return [
    {
      field: 'ma_tt',
      headerName: 'Mã thanh toán',
      width: 150
    },
    {
      field: 'ten_tt',
      headerName: 'Tên thanh toán',
      width: 250
    },
    {
      field: 'han_tt',
      headerName: 'Hạn thanh toán',
      width: 150,
      type: 'number',
      renderCell: params => Number(params.value)
    }
  ];
}

export const paymentTermColumns: DataTableColumn<HanThanhToan>[] = [
  { field: 'ma_tt', headerName: 'Mã thanh toán', width: 150 },
  { field: 'ten_tt', headerName: 'Tên thanh toán', width: 200 },
  { field: 'han_tt', headerName: 'Hạn thanh toán', width: 150 }
];

export const paymentTermDetailColumns: DataTableColumn<HanThanhToan>[] = [
  { field: 'ma_tt', headerName: 'Mã thanh toán', width: 150 },
  { field: 'ten_tt', headerName: 'Tên thanh toán', width: 200 },
  { field: 'ten_tt2', headerName: 'Tên khác', width: 200 },
  { field: 'han_tt', headerName: 'Hạn thanh toán', width: 150 },
  {
    field: 'status',
    headerName: 'Trạng thái',
    width: 150
  }
];
